const unlockedSignatures = new Map<string, string>();

export const getUnlockedSignature = (employeeId: string) =>
  unlockedSignatures.get(employeeId);

export const setUnlockedSignature = (employeeId: string, image: string) => {
  unlockedSignatures.set(employeeId, image);
};

export function clearUnlockedSignatures() {
  unlockedSignatures.clear();
}
